// extracted by mini-css-extract-plugin
module.exports = {"Modal":"RlXeF07J__yxvUUvlhtYe","ultrawide":"TA2Tchj71yFZMRL1_yIck"};